import nBossConnection from 'modules/base/service/nBossConnection';

class RacsTesztlapService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'tesztlapControl';
	}

	/**
	 * @param {object} inputData
	 * @return {Promise<boolean>}
	 */
	setGridManual(inputData) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/setGridManual`, { inputData })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} sheetId
	 * @param {object[]} modifiedSheetData
	 * @return {Promise<boolean>}
	 */
	setSheetCorrection(sheetId, modifiedSheetData) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/setSheetCorrection`, { sheetId, inputData: modifiedSheetData })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new RacsTesztlapService();
